import { render, staticRenderFns } from "./StepsSection.vue?vue&type=template&id=220a8f98&scoped=true&"
import script from "./StepsSection.vue?vue&type=script&lang=js&"
export * from "./StepsSection.vue?vue&type=script&lang=js&"
import style0 from "./StepsSection.vue?vue&type=style&index=0&id=220a8f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a8f98",
  null
  
)

export default component.exports